import { AppliedFilter, ListingPageUrlState, SecondaryProductsIdentifier } from '../../client/redux/products/types';
import { PageType, FilterFacetsNames } from '../../client/hooks/UrlManager/types';

type GetProductPathOptions = Pick<ListingPageUrlState, 'listingPageKey' | 'listingPageType'>;

export const composeGetProductsPath = ({ listingPageKey, listingPageType }: GetProductPathOptions) => {
    const pathPrefix = '/products';
    let typePart: string = '';
    switch (listingPageType) {
        case PageType.CATEGORY:
            typePart = `/category-url-key/${listingPageKey}`;
            break;
        case PageType.BRANDS:
            typePart = `/brandname/${listingPageKey}`;
            break;
        case PageType.LANDING:
            typePart = `/landing/${listingPageKey}`;
            break;
        case PageType.STYLES:
        case PageType.ALLPRODUCTS:
            typePart = `/textsearch`;
            break;
        case PageType.NEWPRODUCTS:
            typePart = `/newproducts`;
            break;
        default:
            break;
    }
    return `${pathPrefix}${typePart}`;
};

export const convertFilters = (filters: AppliedFilter[]) =>
    filters.reduce((filtersObj, filter) => {
        if (filter.values.length === 0) {
            return filtersObj;
        }
        return {
            ...filtersObj,
            [filter.name]: filter.values.join(','),
        };
    }, {});

export const getTypeSpecificQueryParams = (state: ListingPageUrlState) => {
    if (state.listingPageType === PageType.ALLPRODUCTS) {
        return {
            keyword: state.search,
            strictSearch: state.strictSearch,
        };
    }
    if (state.listingPageType === PageType.STYLES) {
        return {
            [FilterFacetsNames.STYLES]: state.listingPageKey,
        };
    }
    return {};
};

export const secondaryProductsPathMap = {
    [SecondaryProductsIdentifier.ALL_PRODUCTS]: composeGetProductsPath({
        listingPageType: PageType.ALLPRODUCTS,
        listingPageKey: '',
    }),
    [SecondaryProductsIdentifier.NEW_PRODUCTS]: composeGetProductsPath({
        listingPageType: PageType.NEWPRODUCTS,
        listingPageKey: '',
    }),
};
